import { Box, Stack, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { CALCULATED_BACKGROUND_COLOR, MANUAL_ENTRY_BACKGROUND_COLOR } from "../gauge-sheet-view/GaugeSheetUtils";
import { useTranslation } from "react-i18next";

export default function GroupManualEntryLegend() {
    const { t } = useTranslation();

    return (
        <Stack
            direction='column'
            sx={{
                alignItems: 'baseline',
                flex: '1 1 auto',
                justifyContent: 'flex-end',
                paddingBottom: theme => theme.spacing(1)
            }}>
            <Table
                size="small"
                aria-label='gauge sheet legend'
                sx={{
                    maxWidth: 300,
                    marginTop: theme => theme.spacing(1),
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2} sx={{ fontSize: '1rem' }}>
                            {t('groupManualEntry.legend.title')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            {t('groupManualEntry.legend.manuallyEntered')}
                        </TableCell>
                        <TableCell>
                            <Box component='span' sx={{
                                verticalAlign: 'middle',
                                border: '1px solid darkgray',
                                width: theme => theme.spacing(2),
                                height: theme => theme.spacing(2),
                                backgroundColor: MANUAL_ENTRY_BACKGROUND_COLOR,
                                display: 'inline-block'
                            }}>
                            </Box>
                        </TableCell>
                    </TableRow>

                    <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            {t('groupManualEntry.legend.calculated')}
                        </TableCell>
                        <TableCell>
                            <Box component='span' sx={{
                                verticalAlign: 'middle',
                                border: '1px solid darkgray',
                                width: theme => theme.spacing(2),
                                height: theme => theme.spacing(2),
                                backgroundColor: CALCULATED_BACKGROUND_COLOR,
                                display: 'inline-block'
                            }}>
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Stack>
    );
}
